import { useBrand } from '@bnnvara/brand';
import { GridItem } from '@bnnvara/grids';
import PropTypes from 'prop-types';
import React from 'react';

import { PublicationCard } from '../../components/cards/PublicationCard';
import { getBrandSlug } from '../../helpers/getBrandSlug';

const ComposableArticleCard = (props) => {
  const { id, slug, wide, subThemes } = props;
  const brand = useBrand();
  return (
    <GridItem
      columnEndSm="span 12"
      columnEndMd={wide ? 'span 12' : 'span 6'}
      columnEndLg={wide ? 'span 6' : 'span 3'}
      columnEndXl={wide ? 'span 6' : 'span 3'}
      key={slug}
    >
      <PublicationCard
        url={`${getBrandSlug(brand.slug)}/artikelen/${slug}`}
        page="Homepage"
        subTheme={subThemes[0]}
        isThemePage
        brand={brand}
        id={id}
        {...props}
      />
    </GridItem>
  );
};

ComposableArticleCard.defaultProps = {
  wide: false,
  subThemes: [],
};

ComposableArticleCard.propTypes = {
  id: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  wide: PropTypes.bool,
  index: PropTypes.number.isRequired,
  subThemes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      description: PropTypes.string,
      slug: PropTypes.string,
      color: PropTypes.string,
      colorHover: PropTypes.string,
      colorActive: PropTypes.string,
      colorVisited: PropTypes.string,
      backgroundImageUrl: PropTypes.string,
      backgroundImageMobileUrl: PropTypes.string,
      parentSlug: PropTypes.string,
      parent: {
        id: PropTypes.string,
        name: PropTypes.string,
        description: PropTypes.string,
        slug: PropTypes.string,
        color: PropTypes.string,
        colorHover: PropTypes.string,
        colorActive: PropTypes.string,
        colorVisited: PropTypes.string,
        backgroundImageUrl: PropTypes.string,
        backgroundImageMobileUrl: PropTypes.string,
      },
    })
  ),
};

export default ComposableArticleCard;
